import { create } from '@theme/create';

export const themed = create(
  new (function () {
    // Header
    this.headerRow = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: [8, 12],
      gap: 6,
    };

    this.headerLeft = {
      flex: 1,
      minWidth: 0,
    };

    this.eyebrow = {
      display: 'block',
      fontSize: '12px',
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      fontWeight: 700,
      mb: [3, 4],
      fontFamily: 'body',
    };

    this.heading = {
      fontSize: ['28px', '32px'],
      fontWeight: 700,
      lineHeight: 1.2,
    };

    // ─── Desktop ─────────────────────────────────────────────────────────────

    this.dtWrap = {
      display: ['none', 'block'],
    };

    this.dtRailBg = {
      height: '1px',
      bg: '#333',
      position: 'relative',
    };

    this.dtRailFill = {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '1px',
      transition: 'width 0.4s ease',
    };

    this.dtDotsRow = {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      top: '-4px',
      left: 0,
      right: 0,
    };

    this.dtYearsRow = {
      display: 'flex',
      justifyContent: 'space-between',
      mt: 3,
    };

    this.dtCards = {
      display: 'flex',
      gap: '14px',
      mt: 4,
    };

    this.dtCard = {
      flex: 1,
      bg: '#1e1e1e',
      borderRadius: '6px',
      p: '10px 10px 14px',
      cursor: 'pointer',
      transition: 'border-color 0.2s',
      minWidth: 0,
      border: '1px solid',
    };

    this.dtCardYear = {
      display: 'block',
      fontSize: '12px',
      fontWeight: 700,
      mb: 4,
    };

    this.dtCardImgPlaceholder = {
      width: '100%',
      aspectRatio: '299/168',
      bg: '#2a2a2a',
      border: '1px solid #2e2e2e',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: 5,
    };

    this.dtCardImgWrap = {
      width: '100%',
      aspectRatio: '299/168',
      mb: 5,
      borderRadius: '4px',
      overflow: 'hidden',
      '& img': { width: '100%', height: '100%', objectFit: 'cover' },
    };

    this.dtCardTitle = {
      display: 'block',
      fontSize: '13px',
      fontWeight: 700,
      color: '#fff',
      lineHeight: 1.4,
    };

    this.dtDetailWrap = {
      mt: 4,
      animation: 'tlFadeUp 0.3s ease',
      '@keyframes tlFadeUp': {
        from: { opacity: 0, transform: 'translateY(6px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
      },
    };

    this.dtDetailInner = {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gap: '1.5rem',
      bg: '#1e1e1e',
      border: '1px solid #2e2e2e',
      borderRadius: '6px',
      p: '1.25rem 1.5rem',
    };

    this.dtDetailImgPlaceholder = {
      aspectRatio: '299/168',
      bg: '#2a2a2a',
      border: '1px solid #2e2e2e',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

    this.dtDetailImgWrap = {
      width: '100%',
      aspectRatio: '299/168',
      borderRadius: '4px',
      overflow: 'hidden',
      '& img': { width: '100%', height: '100%', objectFit: 'cover' },
    };

    this.dtDetailYear = {
      display: 'block',
      fontSize: '12px',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      fontWeight: 700,
      mb: 3,
    };

    this.dtDetailTitle = {
      fontSize: '22px',
      fontWeight: 700,
      color: '#fff',
      mb: 4,
      lineHeight: 1.2,
    };

    this.dtDetailBody = {
      display: 'block',
      fontSize: ['14px', '16px'],
      color: '#888',
      lineHeight: 1.65,
    };

    // ─── Mobile ───────────────────────────────────────────────────────────────

    this.mbWrap = {
      display: ['block', 'none'],
    };

    this.chipsRow = {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: '5px',
      mb: 4,
    };

    this.yrChip = {
      height: '28px',
      borderRadius: '999px',
      border: '1px solid',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: '13px',
      bg: 'transparent',
      outline: 'none',
      transition: 'all 0.2s',
      fontFamily: 'body',
      p: 0,
    };

    this.hint = {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      mb: 6,
    };

    this.hintText = {
      fontSize: '13px',
      color: '#555',
    };

    this.mbItemRow = {
      display: 'grid',
      gridTemplateColumns: '40px 1fr',
    };

    this.mbItemYear = {
      display: 'block',
      fontSize: '13px',
      mb: 1,
      pt: 3,
      transition: 'color 0.2s',
    };

    this.mbItemTitle = {
      display: 'block',
      fontSize: '19px',
      fontWeight: 700,
      mb: 1,
      lineHeight: 1.2,
      cursor: 'pointer',
    };

    this.mbExpandBody = {
      display: 'block',
      fontSize: '14px',
      color: '#888',
      lineHeight: 1.65,
      mb: 8,
    };

    this.mbExpandImgWrap = {
      width: '100%',
      aspectRatio: '299/168',
      mb: 5,
      borderRadius: '6px',
      overflow: 'hidden',
      '& img': { width: '100%', height: '100%', objectFit: 'cover' },
    };

    this.mbExpandImgPlaceholder = {
      width: '100%',
      aspectRatio: '299/168',
      bg: '#1e1e1e',
      border: '1px solid #2a2a2a',
      borderRadius: '6px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: 5,
    };
  })()
);
